import { FileText, Mic, Settings } from "lucide-react";
import type { AppTab } from "../types";
import type { ReactNode } from "react";

const tabs: Array<{ id: AppTab; label: string; icon: typeof Mic }> = [
  { id: "capture", label: "Parler", icon: Mic },
  { id: "notes", label: "Notes", icon: FileText },
  { id: "settings", label: "Réglages", icon: Settings }
];

export function AppShell({
  activeTab,
  onTabChange,
  navigation = true,
  children
}: {
  activeTab: AppTab;
  onTabChange: (tab: AppTab) => void;
  navigation?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="app-shell">
      <header className="topbar">
        {navigation ? (
          <button className="wordmark" onClick={() => onTabChange("capture")} type="button">
            ParleNote
          </button>
        ) : (
          <span className="wordmark">ParleNote</span>
        )}
        <span className="soundline" aria-hidden="true" />
      </header>

      <main className="main-content">{children}</main>

      {navigation && <nav className="bottom-nav" aria-label="Navigation principale">
        {tabs.map(({ id, label, icon: Icon }) => (
          <button
            className={activeTab === id ? "nav-item active" : "nav-item"}
            type="button"
            key={id}
            aria-current={activeTab === id ? "page" : undefined}
            onClick={() => onTabChange(id)}
          >
            <Icon aria-hidden="true" size={22} strokeWidth={1.9} />
            <span>{label}</span>
          </button>
        ))}
      </nav>}
    </div>
  );
}
